/**
 * AutoMazen - Video + Features Section
 * Intersection Observer for autoplay and play/pause controls
 * For Bioethanol Fires website
 */

document.addEventListener('DOMContentLoaded', function() {
  // Handle all video wrappers, not just autoplay
  const videoWrappers = document.querySelectorAll('.am-video-features__video-wrapper');
  
  videoWrappers.forEach(videoWrapper => {
    const video = videoWrapper.querySelector('.am-video-features__video');
    
    if (!video) return;
    
    // Add error handling for video loading
    video.addEventListener('error', function(e) {
      console.error('🎥 Video loading error:', e);
      console.error('Video source:', video.querySelector('source')?.src);
    });
    
    video.addEventListener('loadeddata', function() {
      console.log('🎥 Video loaded successfully');
    });
    
    // Force video to load
    video.load();
    
    // Check if this is an autoplay video
    const isAutoplay = videoWrapper.getAttribute('data-video-autoplay') === 'true';
    
    // Set up play button for all videos that have one
    const playToggle = videoWrapper.querySelector('.am-video-features__play-toggle');
    const playIcon = videoWrapper.querySelector('.am-video-features__play-icon');
    const pauseIcon = videoWrapper.querySelector('.am-video-features__pause-icon');

    // Update button icons
    function updatePlayButton(showPlay) {
      if (playIcon && pauseIcon) {
        if (showPlay) {
          playIcon.style.display = 'block';
          pauseIcon.style.display = 'none';
        } else {
          playIcon.style.display = 'none';
          pauseIcon.style.display = 'block';
        }
      }
    }

    // Update playing state class
    function updatePlayingState(isPlaying) {
      if (isPlaying) {
        videoWrapper.classList.add('is-playing');
      } else {
        videoWrapper.classList.remove('is-playing');
      }
    }

    // Play/Pause toggle button (works for all videos with a button)
    if (playToggle) {
      playToggle.addEventListener('click', function() {
        if (video.paused) {
          video.play();
          updatePlayButton(false);
          updatePlayingState(true);
        } else {
          video.pause();
          updatePlayButton(true);
          updatePlayingState(false);
        }
      });
    }

    // Update button and state on video play/pause events
    video.addEventListener('play', function() {
      updatePlayButton(false);
      updatePlayingState(true);
    });

    video.addEventListener('pause', function() {
      updatePlayButton(true);
      updatePlayingState(false);
    });

    video.addEventListener('ended', function() {
      updatePlayButton(true);
      updatePlayingState(false);
    });

    // For non-autoplay videos: set initial state to paused (show play button)
    if (!isAutoplay) {
      updatePlayButton(true);
      updatePlayingState(false);
      console.log('🎥 Video with custom controls loaded and ready');
      return;
    }
    
    // Handle autoplay videos below (existing behavior)

    // Intersection Observer for autoplay
    const observerOptions = {
      threshold: 0.5, // Play when 50% visible
      rootMargin: '0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          video.play().catch(err => {
            console.log('Autoplay prevented:', err);
          });
          updatePlayButton(false); // Show pause icon
          updatePlayingState(true);
        } else {
          video.pause();
          updatePlayButton(true); // Show play icon
          updatePlayingState(false);
        }
      });
    }, observerOptions);

    observer.observe(videoWrapper);
  }); // Close forEach
});